import style from './style.module.scss'
import classNames from 'classnames'
import { NavLink } from 'react-router-dom'
import { useLocation } from 'react-router'
import type { NavLinkProps } from 'react-router-dom'
import { Base } from '@crossfit/ui'
import { ReactComponent as ExternalLink } from 'components/Admin/images/external-link.svg'
import { NavLink as RouterLink } from 'react-router-dom'

type TabProps = React.ComponentProps<typeof Base> &
  NavLinkProps & {
    disableLink?: boolean
    className?: string
    isExternalLink?: boolean
  }

export function Tab({
  as = NavLink,
  className,
  disableLink,
  isExternalLink,
  activeClassName,
  ...props
}: TabProps) {
  const location = useLocation()
  const isActive = location.pathname === props.to
  if (isActive) {
    return (
      <Base
        as={'div'}
        role='tab'
        className={classNames(style.tab, style.active, className)}
        {...props}
      />
    )
  }

  if (isExternalLink) {
    return (
      <a
        className={classNames(style.tab, style.tabResources)}
        href={disableLink ? null : props.href}
        role='tab'
        target='_blank'
        rel='noreferrer'
        onClick={(e) => {
          disableLink ? props.onClick(e) : null
        }}
      >
        {props.label}
        <ExternalLink className={style.tabIcon} />
      </a>
    )
  } else {
    //remove isActive from props
    const { isActive, ...otherProps } = props
    return (
      <Base
        as={RouterLink}
        role='tab'
        className={classNames(style.tab, className)}
        activeclassname={style.active}
        onClick={props.onClick}
        {...otherProps}
        href={disableLink ? null : props.href}
      />
    )
  }
}
